<template>
  <div class="col-12">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-10 col-lg-6">
        <div class=" row text-center ml-5">
          <h2 class="ui inverted purple text">HEPII day, <strong>Welcome!</strong></h2>
          <p class="mt-4">Please enter your mobile banking credentials (Square or *236#) and start or resume the account opening process.</p>
        </div>
        <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="submitForm()">

          <div class="ui large form mt-5">
            <div class="field floating">
              <label>Phone Number / Email</label>
              <input type="email" v-model="auth.username" placeholder="Phone Number">
              <small class="text-muted mt-1">
                Please include country code e.g 263
              </small>
            </div>
            <div class="field">
              <label>Pin</label>
              <input type="password" v-model="auth.password" placeholder="Pin">
            </div>
            <div class="ui center right aligned two column grid">
              <div class="column"></div>
              <div class="column">
                <!-- <a href="http://localhost:8080/lab/auth" class="ui purple tertiary button">Forgot Password</a> -->
              </div>
            </div>
            <button class="ui button large purple fluid mt-4" type="submit">Login</button>

            <div class="d-flex align-items-end mt-4">
              <p class="fw-lighter">Don't have a profile yet?
                <a @click="register()" class="ui purple tertiary button align-self-end">Register Here!</a>
              </p>
            </div>
            <div class="ui fitted divider mt-2"></div>
            <div class="d-flex align-items-end mt-3">
              <p class="fw-light"> A step-by-step guide on how to open an account as a
                <a @click="openPdf('NewCustomer.pdf')" class="ui purple tertiary button align-self-end">New Customer</a>
                or
                <a @click="openPdf('ExistingCustomer.pdf')" class="ui purple tertiary button align-self-end">Existing Customer</a>
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { utils } from "@/utils/utils";

import { useAuthStore } from '@/stores/auth';

export default {
  name: "CurrentCustomerDetails",
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      customer: {
        phone: "",
        pin: "",
        provider: "CHANNEL",
        action: "LOGIN",
        imei: "abcde",
        street: "",
      },
      auth: {
        username: "",
        password: "",
        channel: "WEB",
      },
      errors: {},
      operations: 0,
    };
  },
  mounted() {
   // Optionally clear state on login page
  },
  methods: {
    register() {
      this.$router.push("/account-opening/register");
    },
    // open Account Opening Guide PDF from the assets folder on a new tab
    openPdf(filename) {

      const pdfUrl = 'https://auth.stewardbank.co.zw/' + filename;
      // Specify the path to the PDF file in the assets folder
      window.open(pdfUrl, '_blank');

    },

    // open pdf url on a new tab




    submitForm() {
      this.post_auth_no_auth('/authentication', { ...this.auth, requestType: 'AUTHENTICATION' }, "Successful").then((res) => {
        // Store auth data
        this.login({
          accessToken: res.body.accessToken,
          userId: res.body.userId,
          phone: res.body.phone,
        });

        this.$router.push("/account-opening/home");

      })
        .catch(e => {
          utils.logger(e);
        });
    },
    login(data) { this.authStore.login(data); },
    ...baseMethods,
  },
};
</script>